/* wsapi3-pag-institucional v1.0 */
/* Deploy Version 2026-09-22 22:08:32 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: 'pag-institucional2',
  version: '1.0',
  updatedAt: '2026-06-02',
  function: 'get',
  get () {
    const pageData = (window.__WS_SERVER_DATA__ || {}).institutionalPage;
    const record = pageData && (pageData.data || pageData.record || pageData);

    if (!record) return;

    const titleEl = document.querySelector('[data-wsjs-sectype="institutional-title"]');
    const contentEl = document.querySelector('[data-wsjs-sectype="institutional-content"]');

    if (titleEl) titleEl.innerHTML = record.title || '';
    if (contentEl) contentEl.innerHTML = record.description || record.content || '';
  }
});
